export const VERSION = "v0.6.23";
export const EXT_TITLE = "VocSum";